export const mastheadNav = [
  { label: '官方验证', href: '#verify' },
  { label: '辨别指南', href: '#guide' },
  { label: '特征对比', href: '#compare' },
  { label: '读者讨论', href: '#discuss' },
];

export const heroMetrics = [
  { value: '16', unit: '类', label: '常见钓鱼手法已收录' },
  { value: '98.6', unit: '%', label: '读者按五步法识别成功' },
  { value: '24', unit: 'h', label: '官方核验结果每日更新' },
];

export const trustCards = [
  {
    icon: 'ri-shield-check-line',
    tag: '入口核验',
    title: '从官方验证入口进入',
    desc: '不要轻信私聊、群消息或短链跳到所谓「最新地址」。先在本页核对官方入口，再决定是否访问。',
  },
  {
    icon: 'ri-fingerprint-line',
    tag: '细节辨识',
    title: '官方特征逐项打勾',
    desc: '域名拼写、页面排版、联系方式三处最容易露馅。按官方特征清单核对，假站几乎撑不过第二项。',
  },
  {
    icon: 'ri-alert-line',
    tag: '反钓鱼提醒',
    title: '出现这些信号立刻退出',
    desc: '强制下载、索要账号密码、频繁弹窗跳转、要求填写隐私信息——任意一条出现，都应当立即关闭页面。',
  },
];

export const verifySteps = [
  {
    no: '01',
    title: '逐字核对域名拼写',
    desc: '把地址栏放大，逐字读出域名。钓鱼站最常用的手法是多一个字母、把零写成字母 o、或加上多余连字符。',
  },
  {
    no: '02',
    title: '确认官方标识与排版',
    desc: '官方页面的刊头、字号与配图风格统一，几乎不会出现错位、拉伸或明显的拼写错误。',
  },
  {
    no: '03',
    title: '观察跳转链路是否异常',
    desc: '从可信入口出发，留意是否被连续重定向到陌生域名。正常情况下，跳转次数越少越安全。',
  },
  {
    no: '04',
    title: '验证联系方式是否真实',
    desc: '把官方公布的联系方式与页面展示的做一次对照。假站往往留的是临时邮箱或无法回复的账号。',
  },
  {
    no: '05',
    title: '以本页核验结果为准',
    desc: '任何自称「官方」的链接，都以本页更新过的官方验证结果为准；存疑时宁可暂时不访问。',
  },
];

export const compareRows = [
  {
    topic: '域名拼写',
    fake: '多字母、少字母，或用数字替换字母混淆',
    real: '域名固定、逐字可读，与官方公布完全一致',
  },
  {
    topic: '页面排版',
    fake: '刊头模糊、字号忽大忽小、配图明显拉伸',
    real: '版式统一，刊头清晰，配图比例正常',
  },
  {
    topic: '弹窗与跳转',
    fake: '一进页面就弹窗、强制跳转、反复重定向',
    real: '无强制弹窗，跳转链路简短可追溯',
  },
  {
    topic: '索要信息',
    fake: '要求填写账号密码、支付信息或隐私资料',
    real: '从不在浏览环节索取账号或支付信息',
  },
  {
    topic: '联系方式',
    fake: '只留临时邮箱，无人回复，查无此号',
    real: '联系方式稳定可查，回应及时',
  },
  {
    topic: '证书提示',
    fake: '浏览器提示证书错误或「不安全」仍引导继续',
    real: '证书正常，无安全警告',
  },
];

export const readingList = [
  {
    no: '01',
    tag: '安全吗',
    title: '黑料地址安全吗？先看这三处再决定点不点',
    summary: '安全与否，多半取决于入口是否官方。这篇把「安全吗」拆成可核对的三个动作，照着做一遍心里就有底。',
    read: '6 分钟',
  },
  {
    no: '02',
    tag: '真假辨别',
    title: '真假辨别实战：一条链接从可疑到确认',
    summary: '用一条真实可疑链接走完辨别流程，看看域名、排版与跳转是怎么一步步把假站暴露出来的。',
    read: '8 分钟',
  },
  {
    no: '03',
    tag: '靠谱吗',
    title: '「靠谱吗」不是感觉，是可以被验证的',
    summary: '靠谱与否不看第一印象，而看可复核的证据。本文给出向官方核验提问的标准话术与判断标准。',
    read: '5 分钟',
  },
  {
    no: '04',
    tag: '防钓鱼',
    title: '是不是钓鱼？四种高频套路与对应的止损动作',
    summary: '从仿冒域名到诱导下载，把最常见的四类套路摆出来，并给出每一步应立刻采取的动作。',
    read: '7 分钟',
  },
  {
    no: '05',
    tag: '安全提醒',
    title: '官方不会做的五件事，记住就不会被骗',
    summary: '官方从不在浏览环节索要密码、不强制下载、不发私聊短链。记住这几条底线，多数陷阱自然失效。',
    read: '4 分钟',
  },
];

export const comments = [
  {
    name: '阿哲不迷路',
    avatar:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20portrait%20of%20a%20calm%20young%20man%20wearing%20a%20knit%20sweater%2C%20soft%20studio%20light%2C%20muted%20cream%20background%2C%20clean%20magazine%20photography%2C%20high%20detail&width=120&height=120&seq=comment-avatar-01&orientation=squarish',
    time: '2 小时前',
    text: '按五步法核对了一遍，发现自己之前收藏的地址域名里多了个连字符，差点中招。这个对比表太实用了。',
    likes: 328,
    replies: 12,
    liked: true,
  },
  {
    name: '柠檬气泡',
    avatar:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20portrait%20of%20a%20cheerful%20young%20woman%20with%20short%20hair%2C%20soft%20natural%20light%2C%20muted%20beige%20background%2C%20clean%20magazine%20photography%2C%20high%20detail&width=120&height=120&seq=comment-avatar-02&orientation=squarish',
    time: '5 小时前',
    text: '一直分不清「靠谱吗」，看完第三篇才知道原来可以拿证据去核验，不是靠感觉。',
    likes: 204,
    replies: 8,
    liked: false,
  },
  {
    name: '深夜编辑部',
    avatar:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20portrait%20of%20a%20thoughtful%20person%20with%20glasses%2C%20soft%20studio%20lighting%2C%20muted%20taupe%20background%2C%20clean%20magazine%20photography%2C%20high%20detail&width=120&height=120&seq=comment-avatar-03&orientation=squarish',
    time: '昨天',
    text: '建议把「官方不会做的五件事」置顶，这几条底线记住了，基本就骗不到人。',
    likes: 156,
    replies: 5,
    liked: false,
  },
];

export const footerColumns = [
  {
    title: '安全指引',
    links: ['官方验证入口', '真假辨别五步', '钓鱼特征对比', '安全提醒订阅'],
  },
  {
    title: '热门话题',
    links: ['黑料地址安全吗', '黑料地址靠谱吗', '是不是钓鱼', '真假辨别方法'],
  },
  {
    title: '关于本刊',
    links: ['编辑说明', '核验原则', '更新记录'],
  },
];